import React from 'react'
import './Fulllogistics.css'

function Fulllogistics() {
  return (
    <div className="fulllogistics-services-container">
      {/* Hero section with image and overlay text */}
      <div className="fulllogistics-services-hero">
        <div className="fulllogistics-services-overlay">
          <h1>Full Logistics</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section with image and text */}
      <div className="fulllogistics-content">
        <div className="fulllogistics-image">
          <img src="/Pics/fulllogistics.jpg" alt="Full Logistics Services" />
        </div>
        
        <p>
          Managing your own logiscs department can be expensive and me-consuming, especially when it comes to internaonal logiscs. Even experienced teams can find it challenging. That's where we come in offering services to simplify things for you.
        </p>
        
        <p>
          By partnering with our team, you gain access to an outsourced logiscs department. We handle the coordinaon and legwork on your behalf, saving you costs and me. In addion to offering more opons and flexibility, we secure the most compeve shipping rates available, and your monthly bill will only come from us.
        </p>
        
        <p>
         Global project logiscs is a complex field, demanding careful planning and preparaon for known challenges while adeptly handling unexpected issues. Each project is unique, presenng a blend of obstacles and complexies based on factors such as cargo type, systems, and project scope.
        </p>
        
        <p>
         Centrex marine services comes to offer you the most integrated logisc services, draed and craed to streamline your supply chain operaons and inculcate efficiency. We cater full logiscs soluons that encompass every aspect of supply chain operaons from planning and transportaon to distribuon.
        </p>
        
        <p>
         Centrex marine services complements its clients' core competencies by offering comprehensive transportaon experse in both origin and desnaon countries. We also bring extensive local knowledge through our project staff situated in all our offices.
        </p>
        
        <p>
          The experts at Centrex marine services include Heavy Li Engineers, Project Managers, Shipping and Chartering Specialists, Air Charter Experts, Freight Forwarders, HSSE Managers, Quality Specialists, Compliance Personnel, and IT Experts. These dedicated professionals are the driving force behind our ability to make things happen in the world of project logiscs.
        </p>
      </div>
    </div>
  )
}

export default Fulllogistics
